import * as type from '../../types';

export function loginAction(data) {
    return {
        type: type.FETCH_LOGIN,
        payload: data
    }
}

// --- ADDED: Send OTP Action ---
export function sendOtpAction(data) {
  return {
    type: type.SEND_OTP_REQUEST,
    payload: data, // expects { identifier }
  };
}

// --- ADDED: Verify OTP Action ---
export function verifyOtpAction(data) {
  return {
    type: type.VERIFY_OTP_REQUEST,
    payload: data, // expects { identifier, otp }
  };
}

export function setUser(data) {
    return {
        type: type.SET_USER,
        data
    }
}


export function signupAction_(data) {
return {
    type: type.FETCH_SIGNUP_REQUEST,
    payload: data,
}
}

export function clearAuthErrors() {
  return {
    type: type.CLEAR_AUTH_ERRORS,
  };
}